export default function returnToJL(fragment = 'homepage') {
  /* @fragment can be homepage or basket */
  return `${window.publicJLSiteDomain}/#${fragment}`;
}
